/* eslint-disable ember/no-computed-properties-in-native-classes, unicorn/prefer-optional-catch-binding */
import Model, { attr, belongsTo } from '@ember-data/model';
import { alias } from '@ember/object/computed';
import { waitFor } from '@ember/test-waiters';

import { apiBaseURL, landingURL } from 'receivable-invoices-js/constants/hosts';

import CURRENCIES from '../constants/currencies';

export default class ReceivableInvoiceModel extends Model {
  @attr amountDue;
  @attr dueDate;
  @attr issueDate;
  @attr paidAt;
  @attr locale;
  @attr number;
  @attr overdue;
  @attr purchaseOrder;
  @attr reference;
  @attr status;
  @attr subtotal;
  @attr termsAndConditions;
  @attr pdfUrl;
  @attr({ defaultValue: false }) directDebitEnabled;
  //Used to display the pdf in the iframe
  @attr pdfSrc;
  @attr vatAmount;
  @attr referralUrl;
  @attr contactEmail;
  @attr linkedQuote;
  @attr header;
  @attr footer;
  @attr performanceDate;
  @attr('hash') customerSnapshot;
  @attr('hash') items;
  @attr('hash') organization;
  @attr('hash') paymentLink;
  @attr('hash') paymentMethods;
  @attr() welfareFundAmount;
  @attr() withholdingTaxAmount;
  @attr() stampDutyAmount;
  @attr('string', { defaultValue: CURRENCIES.default }) currency;
  @alias('amountDue') totalAmount;
  @alias('subtotal') totalExcludingVat;
  @alias('vatAmount') totalVat;
  @attr('boolean', { defaultValue: false }) isEinvoice;

  @belongsTo('receivable-invoices-upload', { inverse: null, async: false })
  receivableInvoicingUpload;
  @belongsTo('receivable-invoices-upload', { inverse: null, async: false })
  termsConditionsUpload;

  get paymentMethod() {
    return this.paymentMethods[0];
  }

  get organizationSnapshot() {
    return this.organization;
  }

  @waitFor
  async fetchReferralUrl() {
    try {
      let response = await fetch(`${apiBaseURL}/v5/organizations/${this.organization.id}/shared`, {
        method: 'GET',
      });
      if (response.ok) {
        let payload = await response.json();
        this.referralUrl = payload?.data?.attributes?.referral_url;
      } else {
        this.referralUrl = landingURL;
      }
    } catch (error) {
      this.referralUrl = landingURL;
    }
  }

  async setPdfSrc() {
    if (!this.pdfUrl) return;
    let reader = new FileReader();
    let handler = () => {
      this.pdfSrc = reader.result;
    };

    try {
      let response = await fetch(this.pdfUrl, { method: 'GET' });
      let blob = await response.blob();

      reader.addEventListener('load', handler);
      reader.readAsDataURL(blob);
    } catch {
      this.pdfSrc = null;
    } finally {
      reader.removeEventListener(handler);
    }
  }
}
